import * as React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { PageTopBarBreadcrumb } from '../_pageWrappers/wrapperLayouts/elements/topBar/TopBar';
import { ProtectedPageContext } from '../_contexts/ProtectedPageContext';
import { UserPageWrapper } from '../_pageWrappers/UserPageWrapper';
import ActionPlanPageView from './components/ActionPlanPageView';

export default function ActionPlanPage(): JSX.Element {
    
    const params = useParams<{ actionPlanId: string }>();
    const [breadCrumbs, setBreadCrumbs] = React.useState<PageTopBarBreadcrumb[]>([]);
    
    return (
        <UserPageWrapper breadCrumbs={breadCrumbs}>
            {params.actionPlanId
                ? <InnerActionPlanPage actionPlanId={params.actionPlanId} onBreadCrumbsChanged={setBreadCrumbs} />
                : <span>ugyldig url</span>
            }
        </UserPageWrapper>
    );
}

type InnerActionPlanPageProps = {
    actionPlanId: string;
    onBreadCrumbsChanged:(breadCrumbs:PageTopBarBreadcrumb[]) => void;
}
function InnerActionPlanPage(props:InnerActionPlanPageProps):JSX.Element
{
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const returnDestination = queryParams.get('retdist');
    const returnId = queryParams.get('retid');

    const [redirectToList, setRedirectToList] = React.useState(false);
    const [actionPlanTitle, setActionPlanTitle] = React.useState('');

    const activeUser = React.useContext(ProtectedPageContext).user;

    function handleDeleted()
    {
        setRedirectToList(true);
    }

    let returnUrl = '/actionplans';
    if(activeUser?.permissionGroupId === 'user')
    {
        returnUrl = `/`;
    }
    else {
        if (returnDestination === 'workplaceassessment') {
            returnUrl = `/workplaceassessments/${returnId ?? ''}`;
        } 
        else if (returnDestination === 'article') {
            returnUrl = `/articles/${returnId ?? ''}`;
        }
        else if (returnDestination === 'dashboard') {
            returnUrl = `/`;
        }
    }

    const breadCrumbs:PageTopBarBreadcrumb[] = [
        { text: 'Handleplaner', url:returnUrl },
        ...(actionPlanTitle ? [{ text: actionPlanTitle, url:'' }] : [])
    ];

    React.useEffect(() =>
    {
        props.onBreadCrumbsChanged(breadCrumbs);
    }, [returnUrl, actionPlanTitle]);

    return (
        <>
            {redirectToList &&
                <Navigate to={`/actionplans`} replace />
            }

            {props.actionPlanId 
                ? <ActionPlanPageView 
                        actionPlanId={props.actionPlanId}
                        onBack={handleDeleted}
                        onTitleChanged={setActionPlanTitle} />
                : <span>ugyldig url</span>
            }
        </>
    );
}
